<h2 mat-dialog-title>Create Sell Contract</h2>

<mat-dialog-content>
  <form [formGroup]="form" class="contract-form">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Name</mat-label>
      <input matInput type="text" formControlName="name" placeholder="Enter contract name">
      <mat-error>{{ getErrorMessage('name') }}</mat-error>
    </mat-form-field>

    <app-email-login-field [control]="loginInfoEmailControl" (loginInfoChange)="onLoginInfoChange($event)"
      appearance="outline">
    </app-email-login-field>

    <div class="content-row">
      <mat-form-field appearance="outline" class="w-full">
        <mat-label>Target Coins (K)</mat-label>
        <input matInput type="number" formControlName="target_coins" placeholder="e.g. 100">
        <mat-icon matPrefix>monetization_on</mat-icon>
        <mat-error>{{ getErrorMessage('target_coins') }}</mat-error>
      </mat-form-field>

      <div class="toggle-row">
        <mat-button-toggle-group formControlName="target_type" aria-label="Target Type">
          <mat-button-toggle value="sent">Sent</mat-button-toggle>
          <mat-button-toggle value="received">Received</mat-button-toggle>
        </mat-button-toggle-group>
        <span class="toggle-label">Calculate coins with: </span>
      </div>
    </div>

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Note (optional)</mat-label>
      <textarea matInput formControlName="note" placeholder="Enter a note" rows="1"></textarea>
      <mat-icon matPrefix>notes</mat-icon>
    </mat-form-field>

    @if (isAdmin) {
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Fee (optional)</mat-label>
      <input matInput type="number" formControlName="fee" placeholder="0">
      <mat-icon matPrefix>percent</mat-icon>
      <mat-error>{{ getErrorMessage('fee') }}</mat-error>
    </mat-form-field>
    }

    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Proxy Country (optional)</mat-label>
      <mat-select formControlName="country">
        <mat-option value="">Any</mat-option>
        @for (country of countries; track country.code) {
        <mat-option [value]="country.code">{{ country.name }}</mat-option>
        }
      </mat-select>
      <mat-hint>Match the IP used for this contract to the customer's country</mat-hint>
    </mat-form-field>

    <mat-checkbox formControlName="in_pool">
      Include in buy pool (eligible for auto-buy)
    </mat-checkbox>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="loading">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()"
    [disabled]="loading || form.invalid || !isAccountSelected()">
    @if (loading) {
    <mat-spinner diameter="20"></mat-spinner>
    } @else {
    Create Contract
    }
  </button>
</mat-dialog-actions>